//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () { return { list: [] } },
  created () { this.$ajax.get(this.$api.cpCardMyList).then(r => { this.list = r || [] }) }
}



// WEBPACK FOOTER //
// ./src/views/innovation/context-puzzle/collection.vue